import { useEffect, useState } from "react";

export type ChartMode = "line" | "bar" | "area";

const readChartMode = (key: string, fallback: ChartMode): ChartMode => {
	try {
		const mode = localStorage.getItem(key);
		return mode === "line" || mode === "bar" || mode === "area" ? mode : fallback;
	} catch { return fallback; }
};

export const useChartMode = (key: string, fallback: ChartMode = "line") => {
	const [preference, setPreference] = useState(() => ({ key, mode: readChartMode(key, fallback) }));
	const mode = preference.key === key ? preference.mode : readChartMode(key, fallback);
	useEffect(() => {
		const sync = () => setPreference({ key, mode: readChartMode(key, fallback) });
		sync();
		const onStorage = (event: StorageEvent) => { if (event.key === key || event.key === null) sync(); };
		window.addEventListener("storage", onStorage);
		return () => window.removeEventListener("storage", onStorage);
	}, [key, fallback]);
	const changeMode = (next: ChartMode) => {
		setPreference({ key, mode: next });
		try { localStorage.setItem(key, next); } catch { /* Keep the selection for this session. */ }
	};
	return [mode, changeMode] as const;
};
